import { useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getAllKnockStatuses } from '../api'

export const useGetKnockStatusesOnMount = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getAllKnockStatuses())
  }, [dispatch])
}
